import React from "react";
import { Helmet } from "react-helmet-async";
import { getState } from "core-web/state";
import { inServer } from "core-web/constants";

const CookieInformation = () => {
    const locale = getState("application")?.locale || "sv_SE";
    const lang = locale.substr(0, 2).toUpperCase();

    return !inServer ? (
        <Helmet
            script={[
                {
                    type: "text/javascript",
                    charset: "UTF-8",
                    src: "https://policy.app.cookieinformation.com/uc.js",
                    id: "CookieConsent",
                    "data-culture": lang,
                    "data-gcm-version": "2.0",
                },
            ]}
        />
    ) : null;
};

export default CookieInformation;
